<div class="px-1 py-1 space-y-1 text-center">
  <div>
    <app-widget-box name="Data Indexer" description="Blockchain data retrieval mechanism" [dark]="true">
      <div class="flex flex-wrap gap-1 justify-center mx-auto">
        @for (indexer of indexers(); track $index) {
        <div class="w-28">
          <app-widget-option [value]="indexer.name" [active]="settings().indexer == indexer.id"
            (clicked)="changeIndexer(indexer.id)">
          </app-widget-option>
        </div>
        }
      </div>
      <p>GraphQL data service provider node</p>
      <div class="flex flex-wrap gap-1 justify-center mx-auto">
        @for (provider of graphql_providers(); track $index) {
        <div class="w-28">
          <app-widget-option [value]="provider.name" [active]="settings().graphql == provider.id"
            (clicked)="changeGraphqlProvider(provider.id)">
          </app-widget-option>
        </div>
        }
      </div>
      <p>JSON-RPC data service provider node</p>
      <div class="flex flex-wrap gap-1 justify-center mx-auto">
        @for (provider of jsonrpc_providers(); track $index) {
        <div class="w-28">
          <app-widget-option [value]="provider.name" [active]="settings().jsonrpc == provider.id"
            (clicked)="changeJsonrpcProvider(provider.id)">
          </app-widget-option>
        </div>
        }
      </div>
    </app-widget-box>
  </div>
</div>